import * as React from 'react';
import './footer.css';
import FullLogo from './icons/fullLogo';

export function Footer(): React.ReactElement {
  return (
    <footer>
      <FullLogo className="footer__logo" />
      <div className="footer__address">ul. Strzelecka 7B, 80-803 Gdańsk</div>
      <div className="footer__copyright">&copy;2021 advocare.pl</div>
    </footer>
  );
}
